import { BoxProps, Text, VStack } from "@chakra-ui/react";
import { useISOCountDown } from "hooks";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setTimerExpire } from "store/slices";

export interface QuoteTimerProps extends BoxProps {
  time?: string;
  onExpired?: (iso: string) => void;
  title?: string;
  checkExpire?: boolean;
}

export function QuoteTimer(props: QuoteTimerProps) {
  const { time, onExpired, title, checkExpire, ...xprops } = props;

  const { timer, expired } = useISOCountDown(
    time ?? new Date().toISOString(),
    "--:--",
    (iso, expired) => !!expired && !!onExpired && onExpired(iso)
  );

  const dispatch = useDispatch();

  useEffect(() => {
    expired && checkExpire && dispatch(setTimerExpire(expired));
  }, [expired, dispatch, checkExpire]);

  return (
    <VStack {...xprops}>
      <Text fontWeight="600" textAlign="center">
        <Text as="span" mr="4px">
          {title ? title : "Quote updates in"}
        </Text>{" "}
        <Text as="span" color="#6FBE45">
          {timer ?? "--:--"}
        </Text>
      </Text>
    </VStack>
  );
}
